import React from "react";
import {ItemImageType} from "./ItemImageType";
import './ItemImage.sass';
import './ItemImageGenerated.sass';

type Props = {
    item: string,
}

export default function ItemImage({ item }: Props) {
    const itemType = item.replace(/[^a-zA-Z0-9]/g, '') as ItemImageType;
    return <i className={`dysonSphereItemImage itemType_${itemType}`}></i>
}
